/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { Artist } from './artist';
import { Company } from './company';
import { Lover } from './lover';
import { Footer } from "../Footer";
import { useWindowDimensions } from '../utils/helpers';
import { images, mobileImages } from '../constants';
import { useParams, useRouteMatch } from 'react-router-dom'

import Unsubscribe from './unsubscribe';

const randomImages = Object.values(images).filter((img) => img.includes('fsk'));
const randomMobileImages = Object.values(mobileImages).filter((img) => img.includes('fsk'));
const randomNumber = Math.floor(Math.random() * randomImages.length);
const randomMobileNumber = Math.floor(Math.random() * randomMobileImages.length);

let titles = [
    {
        label: 'initial',
        title: 'start by selecting your account type',
        subtitle: '<span style="font-size: 21px">Don’t worry, <b>itch</b> is absolutely free.</span>'
    },
    {
        label: 'fa',
        title: 'fashion artist',
        subtitle: `For <b>fashion designers</b>, <b>models</b>, <b>photographers</b>, <b>videographers</b>, <b>hair stylists</b>,<br/>
        <b>makeup artists</b>, <b>stylists</b>, <b>nail artists</b>, <b>creative directors</b> & <b>retouchers</b>.`
    },
    {
        label: 'fc',
        title: 'fashion company',
        subtitle: `For any fashion <b>brand</b>, <b>service</b> or <b>agency</b> such as clothing brands,<br/>
        model agencies, salons, studios, production companies, etc.`
    },
    {
        label: 'fl',
        title: 'fashion lover',
        subtitle: `For anyone who’s a fashion editor, blogger, merchandiser,<br/>
        forecaster, researcher, buyer, marketing and PR or just the fashion fanatic.`
    },
];

let titles2 = [
    {
        label: 'initial',
        title: 'start by selecting<br /> your account type',
        subtitle: ''
    },
    {
        label: 'fa',
        title: 'fashion artist',
        subtitle: `For <b>fashion designers</b>, <b>models</b>,<br /> <b>photographers</b>, <b>videographers</b>, <b>hair stylists</b>,<br/>
        <b>makeup artists</b>, <b>stylists</b>, <b>nail artists</b>,<br />
        <b>creative directors</b> & <b>retouchers</b>.`
    },
    {
        label: 'fc',
        title: 'fashion company',
        subtitle: `For any fashion <b>brand</b>, <b>service</b> or <b>agency</b><br />
        such as clothing brands, model agencies,<br />
        salons, studios, production companies, etc.`
    },
    {
        label: 'fl',
        title: 'fashion lover',
        subtitle: `For anyone who’s a fashion editor, blogger,<br />
        merchandiser, forecaster, researcher, buyer,<br />
        marketing and PR or just the fashion fanatic.`
    },
];

export default function SignUp() {
    const { code } = useParams()
    const match = useRouteMatch('/unsubscribe/:code')
    const [index, setIndex] = useState(0);
    const [opacity, setOpacity] = useState(0);
    const [display, setDisplay] = useState({
        fa: false,
        fc: false,
        fl: false
    });
    const { windowWidth } = useWindowDimensions();

    const onSetDisplayAll = (d) => {
        setDisplay({
            fa: d,
            fc: d,
            fl: d
        });
        changeImage(0, 0);
    };
    const changeImage = (i, op) => {
        setOpacity(op);
        op === 0 ? setIndex(0) : setIndex(i + 1);
    }

    let displayIsTrue = Object.values(display).filter((item) => item);
    
    return (
        <>
            { match ? <Unsubscribe/> : null }
            
            <div className="wrapper">
                {windowWidth > 1030 ?
                    <div id="signupMain" className={displayIsTrue.length > 0 ? 'd-none' : ''}>
                        <img className="signup-bg top" src={`${randomImages[randomNumber]}`} alt="background" />
                        {titles.slice(1).map(({ label, title }, i) =>
                            <img
                                key={label}
                                id={label + "Image"}
                                className="signup-bg"
                                style={{ opacity: i + 1 === index ? opacity : null }}
                                src={`${images[label + '.jpg']}`}
                                alt={title}
                            />
                        )}
                        <div id="accountSelection">
                            <div id="accountTypes">
                                <div id="circles">
                                    {titles.slice(1).map(({ label }, i) =>
                                        <div
                                            key={label}
                                            id={label + "Circle"}
                                            className="circle"
                                            style={{ opacity: i + 1 !== index && index !== 0 ? .5 : null }}
                                            onClick={() => setDisplay({
                                                [label]: true
                                            })}
                                            onMouseEnter={() => changeImage(i, 1)}
                                            onMouseLeave={() => changeImage(0, 0)}
                                        >
                                            <p>{label}</p>
                                        </div>
                                    )}
                                </div>
                                <div id="diagonals" style={{ opacity: index === 0 ? null : .5 }}>
                                    <div id="rightDiagonal" className="diagonal-line"></div>
                                    <div id="leftDiagonal" className="diagonal-line"></div>
                                </div>
                            </div>
                            <div id="selectionText">
                                <p id="selectionTitle" className="pink-text">{titles[index].title}</p>
                                <p id="selectionSubtitle">{parse(titles[index].subtitle)}</p>
                            </div>
                        </div>
                    </div>

                    :

                    <div id="signupMain" className={displayIsTrue.length > 0 ? 'd-none' : ''}>
                        <img className="signup-bg top" src={`${randomMobileImages[randomMobileNumber]}`} alt="background" />
                        {titles2.slice(1).map(({ label, title }, i) =>
                            <img
                                key={label}
                                id={label + "Image"}
                                className="signup-bg"
                                style={{ opacity: i + 1 === index ? opacity : null }}
                                src={`${images[label + '.jpg']}`}
                                alt={title}
                            />
                        )}
                        <div id="accountSelection">
                            <div id="accountTypes">
                                <div id="circles">
                                    {titles2.slice(1).map(({ label }, i) =>
                                        <div
                                            key={label}
                                            id={label + "Circle"}
                                            className="circle"
                                            style={
                                                i + 1 !== index ?
                                                    {
                                                        opacity: index !== 0 ? .5 : null
                                                    }
                                                    :
                                                    {
                                                        border: '2px solid #EC0F69',
                                                        background: 'rgba(236, 15, 105, .5)'
                                                    }
                                            }
                                            onClick={() => changeImage(i, 1)}
                                        >
                                            <p style={{ color: i + 1 !== index ? '#A5A5A5' : '#EC0F69' }}>{label}</p>
                                        </div>
                                    )}
                                </div>
                                <div id="diagonals" style={{ opacity: index === 0 ? null : .5 }}>
                                    <div id="rightDiagonal" className="diagonal-line"></div>
                                    <div id="leftDiagonal" className="diagonal-line"></div>
                                </div>
                            </div>
                            <div id="selectionText">
                                <p id="selectionTitle" className="pink-text">{parse(titles2[index].title)}</p>
                                <p id="selectionSubtitle">{parse(titles2[index].subtitle)}</p>
                            </div>
                            {index !== 0 ?
                                <div className="signup-buttons-div">
                                    <button
                                        className="footer-buttons pink-text select"
                                        onClick={() => setDisplay({
                                            [titles2[index].label]: true
                                        })}
                                    >Select
                                    </button>
                                    <button className="back-button" onClick={() => changeImage(0, 0)}>Back</button>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                }
                <Artist displayAll={display.fa} passDisplayAll={onSetDisplayAll} code={code} />
                <Company displayAll={display.fc} passDisplayAll={onSetDisplayAll} />
                <Lover displayAll={display.fl} passDisplayAll={onSetDisplayAll} />
            </div>

            {index === 0 ? <Footer displayAll={!displayIsTrue.length > 0} /> : ''}
        </>
    )
}
